import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const Care: FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 48 48" fontSize="48px" fill="none" {...props}>
      <path
        d="M8 42H5c-1.1 0-2-.9-2-2V26c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2ZM35.375 34.962l6.937-2.737c1.325-.525 2.75-.125 3.375 1.025.738 1.35.125 3.225-1.35 4.187-.075.05-.15.088-.212.125l-11.838 6.575a6.771 6.771 0 0 1-5.625.45s-11.3-4.125-16.65-6.087"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 1.5}
        strokeMiterlimit={10}
      />
      <path
        d="M10 27.75c1.7-.475 3.55-.75 5.5-.75 4 0 7.625 1.125 10.25 2.925l.1.075h8.587a2.571 2.571 0 0 1 2.576 2.575c0 1.062-.65 2.012-1.625 2.4a14.749 14.749 0 0 1-5.438 1.037H24M33 5.55C34 4.25 35.887 3 37.925 3 41.825 3 45 6.162 45 10.075c0 1.95-.788 3.712-2.063 4.987C40.462 17.55 33 25 33 25s-7.463-7.45-9.938-9.95A7.02 7.02 0 0 1 21 10.075C21 6.175 24.162 3 28.075 3 30.112 3 32 4.262 33 5.55Z"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 1.5}
        strokeMiterlimit={10}
      />
    </Icon>
  )
}

export default Care
